import rootAPIs from '@/api/rootAPIs';


export default {
  /**
   * Get the CMS text from the CMS API and add it to the state.
   *
   * @param {function} commit - The commit function for module mutations
   * @param {number} utilityID - The utility ID to get text for
   * @param {string} language - The language code for translation (default: 'en')
   */
  updateText({ commit }, { utilityID, language = 'en' }) {
    return rootAPIs.retrieveMarketplaceText(utilityID, language)
      .then(data => commit('setText', { cmsText: data }));
  },
};
